export default {
    letSignYouIn: `เข้าสู่ระบบ`,
    pleaseProvideYourUsernameAndPassword: 'กรอกชื่อผู้ใช้และรหัสผ่าน',
    username: 'ชื่อผู้ใช้',
    password: 'รหัสผ่าน',
    login: 'เข้าสู่ระบบ',
    // Sign Up
    resendInSeconds: `ส่งใหม่ใน {{no}} วินาที`,

    createAccount: 'สร้างบัญชี',
    letSignYouUp: 'ให้เราช่วยคุณสมัคร',
    pleaseProvideYourFirstnameAndLastnameForSigningUp: 'กรุณาใส่ชื่อและนามสกุลเพื่อสมัคร',
    gender: 'เพศ',
    contactNo: 'เบอร์ติดต่อ',
    sendCode: 'ส่งรหัส',
    signUp: 'สมัคร',
    accountLogin: 'เข้าสู่ระบบบัญชี',

    newUserSignUpHere: 'สมัครสมาชิก',
    forgotPassword: 'ลืมรหัสผ่าน?',
    clickHere: 'คลิกที่นี่',

    resetPassword: 'รีเซ็ตรหัสผ่าน',
    newPassword: 'รหัสผ่านใหม่',
    pleaseEnterYourNewPasswordBelow: 'กรุณาใส่รหัสผ่านใหม่',

    verifyCode: 'รหัสยืนยัน',
    enterReceiveVerificationCodeBelow: 'ใส่รหัสยืนยันที่ได้รับด้านล่าง',
    submit: 'ส่ง',

    verifyExistingUser: 'ยืนยันผู้ใช้',
    pleaseEnterYourContactToVerifyExistingUser: 'ใส่เบอร์ติดต่อเพื่อยืนยันตัวตน',
};